import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import {
  genericUnitField,
  ghgCategoryField,
  remotePercentageField,
  employeeQuantityField,
} from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import { locationCountryField } from './common/locationFields';

export const ceeCommutingMetadata = {
  displayName: msg({
    message: 'CEE Commuting',
    context: 'Activity data schema name for CEE Commuting',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    country: locationCountryField,
    employee_remote_time_percent: remotePercentageField,
    quantity: employeeQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
